/**
 * Global Countdown Handler
 * Inicializa los countdowns con [data-countdown] y data-end
 */
(function () {
  function initGlobalCountdowns() {
    const countdowns = document.querySelectorAll('[data-countdown]:not([data-countdown-initialized])');

    if (countdowns.length === 0) return;

    countdowns.forEach(function (countdown) {
      countdown.setAttribute('data-countdown-initialized', 'true');

      const endDateString = countdown.dataset.end;

      if (!endDateString || endDateString.trim() === '') return;

      let parsedDate;
      try {
        let localDateString = endDateString.trim();
        if (localDateString.match(/^\d{4}-\d{2}-\d{2}/)) {
          localDateString = localDateString.replace(/^(\d{4})-(\d{2})-(\d{2})/, '$1/$2/$3');
        }
        parsedDate = new Date(localDateString);
        if (isNaN(parsedDate.getTime())) return;
      } catch (e) {
        return;
      }

      const endTime = parsedDate.getTime();

      const elements = {
        days: countdown.querySelector('[data-countdown-days]'),
        daysContainer: countdown.querySelector('[data-countdown-days-container]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };

      if (!elements.hours || !elements.minutes || !elements.seconds) return;

      function updateCountdown() {
        const now = new Date().getTime();
        const distance = endTime - now;

        if (distance <= 0) {
          if (elements.daysContainer) elements.daysContainer.style.display = 'none';
          if (elements.hours) elements.hours.textContent = '00';
          if (elements.minutes) elements.minutes.textContent = '00';
          if (elements.seconds) elements.seconds.textContent = '00';
          if (countdown._countdownInterval) {
            clearInterval(countdown._countdownInterval);
            countdown._countdownInterval = null;
          }
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((distance / (1000 * 60)) % 60);
        const seconds = Math.floor((distance / 1000) % 60);

        if (elements.daysContainer) {
          elements.daysContainer.style.display = days > 0 ? 'flex' : 'none';
        }
        if (elements.days) elements.days.textContent = String(days).padStart(2, '0');
        if (elements.hours) elements.hours.textContent = String(hours).padStart(2, '0');
        if (elements.minutes) elements.minutes.textContent = String(minutes).padStart(2, '0');
        if (elements.seconds) elements.seconds.textContent = String(seconds).padStart(2, '0');

        requestAnimationFrame(function () {
          countdown.classList.remove('tw-opacity-0');
          countdown.classList.add('tw-opacity-100');
        });
      }

      updateCountdown();
      countdown._countdownInterval = setInterval(updateCountdown, 1000);
    });
  }

  function initializeCountdowns() {
    requestAnimationFrame(function () {
      setTimeout(initGlobalCountdowns, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCountdowns);
  } else {
    initializeCountdowns();
  }

  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-countdown-initialized]').forEach(function (el) {
        el.removeAttribute('data-countdown-initialized');
      });
      setTimeout(initGlobalCountdowns, 100);
    });
  }
})();
